import React from 'react';
import { render } from 'react-dom';
import { Router, useRouterHistory } from 'react-router';
import { createHistory } from 'history';

import '../css/app.scss';

import humanRoutes from './human/humanRoutes';
import courseRoutes from './course/courseRoutes';
import horseRoutes from './horse/horseRoutes';

import rpLibs from './rpLibs';
import analyticsPage from './analyticsPage';

rpLibs.beforeRender();

const routes = [...humanRoutes, courseRoutes, horseRoutes];

const browserHistory = useRouterHistory(createHistory)({
    basename: '/profile/',
});

const isBloodstockRoute = () => {
    /*
        we check here if we are on bloodstock profile page OR on normal horse profile page
        one of the differences are exactly the logo rendered on both pages
        on both page 2 logos are rendered (one is not visible), but only on bloodstock page one of the logos has href which includes 'bloodstock'
    */
    const logosElements = document.querySelectorAll('[data-test-selector="link-navigationRpLogo"]');
    return Array.from(logosElements)
        .filter(logo => logo.tagName === 'A' && logo.href.includes('bloodstock')).length > 0;
};

// NOTE: [JP-9795] This prevent trigger analytics when user go to horse profile and after that redirect automatically to /form
// EXAMPLE: /profile/horse/<horseId>/<horseName> -> /profile/horse/<horseId>/<horseName>/form
const onRouteUpdate = () => {
    const { pathname, search, hash } = browserHistory.getCurrentLocation();
    const newRoute = `${pathname}${search}${hash}`;
    const routeParts = newRoute.split('/').filter(routePart => routePart !== '');

    const isBloodstockProfile = isBloodstockRoute();

    if ((!newRoute.includes('/form') && routeParts.length > 3) || isBloodstockProfile) {
        analyticsPage();
    }
};

render(
    <Router routes={routes} history={browserHistory} onUpdate={() => { onRouteUpdate(); }} />,
    document.querySelector('main')
);

rpLibs.afterRender();


export { browserHistory as default };



// WEBPACK FOOTER //
// ./src/js/index.jsx